import {motion} from "framer-motion";
import {ReactNode} from "react";

interface MainDesignProps {
    children: ReactNode;
    childrenOutsideRelativePosition?: ReactNode;
    minHeight?: string;
    containerStyles?: string;
    removeSectionOverflowHidden?: boolean;
    hideBackgroundImage?: boolean;
    minHeightChildrenDiv?: string;
    disableAnimation?: boolean;
    useGradientBackground?: boolean;
    useSolidGradientTop?: boolean;     // Solid color matching gradient top (#1a1a2e) for header
    useSolidGradientBottom?: boolean;  // Solid color matching gradient bottom (#0f0f1e) for footer
    whiteBackground?: boolean;
    addOrb?: boolean;
}

export default function MainDesign(props: MainDesignProps) {
    const {
        children,
        childrenOutsideRelativePosition,
        minHeight,
        containerStyles,
        removeSectionOverflowHidden,
        hideBackgroundImage,
        minHeightChildrenDiv,
        disableAnimation,
        useGradientBackground,
        useSolidGradientTop,
        useSolidGradientBottom,
        whiteBackground,
        addOrb = false
    } = props;

    const sectionStyle: React.CSSProperties = {
        minHeight: `${minHeight ? minHeight : '70vh'}`,
    };

    if (whiteBackground) {
        sectionStyle.background = '#ffffff';
    } else if (useSolidGradientTop) {
        sectionStyle.background = '#1a1a2e';  // Matches the top of the gradient for header
    } else if (useSolidGradientBottom) {
        sectionStyle.background = '#0f0f1e';  // Matches the bottom of the gradient for footer
    } else if (useGradientBackground) {
        sectionStyle.background = 'linear-gradient(180deg, #1a1a2e 0%, #0f0f1e 100%)';
    } else if (!hideBackgroundImage) {
        sectionStyle.backgroundImage = 'url(https://produkacja.s3.eu-central-1.amazonaws.com/web/elements/pattern-dark.png)';
        sectionStyle.backgroundSize = 'auto';
        sectionStyle.backgroundRepeat = 'repeat';
        sectionStyle.backgroundPosition = 'center center';
    }

    // Determine background class - don't apply bg-secondary-dark when using gradient/solid backgrounds
    const bgClass = whiteBackground
        ? 'bg-white'
        : (useGradientBackground || useSolidGradientTop || useSolidGradientBottom)
            ? ''
            : 'bg-secondary-dark';

    return (
        <section
            className={`position-relative ${bgClass} ${removeSectionOverflowHidden ? '' : 'overflow-hidden'}`}
            style={sectionStyle}
        >
            {useGradientBackground && addOrb && (
                <>
                    <div className="position-absolute top-0 start-50 translate-middle-x" style={{zIndex: 0}}>
                        <div
                            className="position-absolute"
                            style={{
                                width: '280px',
                                height: '280px',
                                borderRadius: '50%',
                                background: 'radial-gradient(circle, rgba(245, 158, 12, 0.06) 0%, transparent 70%)',
                                top: '-80px',
                                right: '-140px'
                            }}
                        />
                        <div
                            className="position-absolute"
                            style={{
                                width: '260px',
                                height: '260px',
                                borderRadius: '50%',
                                background: 'radial-gradient(circle, rgba(42, 209, 103, 0.06) 0%, transparent 70%)',
                                top: '-60px',
                                left: '-140px'
                            }}
                        />
                    </div>
                </>
            )}
            {
                !hideBackgroundImage && !useGradientBackground && !whiteBackground && <div
                    className="position-absolute top-0 start-0 h-100 w-100"
                    style={{
                        background: 'radial-gradient(50% 50% at 50% 50%, rgba(42, 51, 66, 0) 0%, #2A3342 100%)',
                    }}
                />
            }

            {childrenOutsideRelativePosition}
            <motion.div
                className={`position-relative ${containerStyles}`}
                initial={disableAnimation ? undefined : {opacity: 0, y: 50}}
                animate={disableAnimation ? undefined : {opacity: 1, y: 0}}
                style={removeSectionOverflowHidden ? {minHeight: minHeightChildrenDiv ? minHeightChildrenDiv : undefined} : {
                    zIndex: 1,
                    minHeight: minHeightChildrenDiv ? minHeightChildrenDiv : undefined
                }}
            >
                {children}
            </motion.div>
        </section>
    );
}